var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _ellipse, _ellipse2, _ellipse3, _ellipse4, _g, _g2, _g3, _g4, _g5, _path55, _path56, _path57, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpoweringCardItem1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 340 328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "react-native-bg_svg__a",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#react-native-bg_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#121317",
    d: "M0 0h340v328H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#react-native-bg_svg__b)",
    d: "M0 0h340v328H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#react-native-bg_svg__c)",
    d: "M0 0h340v328H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "react-native-bg_svg__d",
    width: 483,
    height: 441,
    x: -72,
    y: -96,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M-29.492 130.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M12.688 130.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM54.828 130.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM96.977 130.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M139.148 130.972v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM181.297 130.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM223.438 130.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM265.617 130.972v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M307.758 130.972v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM-8.602 166.609v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M33.57 166.609v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM75.719 166.609v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M117.867 166.609v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M160.039 166.609v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM202.188 166.609v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M244.328 166.609v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM286.508 166.609v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M-29.117-12.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M13.047-12.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM55.195-12.995v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM97.336-12.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M139.516-12.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M181.656-12.995v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM223.805-12.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M265.977-12.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM308.125-12.995v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM-29.492 202.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M12.688 202.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M54.828 202.683v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M96.977 202.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM139.148 202.683v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M181.297 202.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM223.438 202.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM265.617 202.683v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M307.758 202.683v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM-8.227 23.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM33.93 23.033v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M76.094 23.033v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M118.234 23.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M160.398 23.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M202.555 23.033v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M244.703 23.033v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM286.859 23.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M329.023 23.033v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM-8.602 238.704v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3zM33.57 238.704v22.601l19.776 11.3 19.775-11.3v-22.601l-19.775-11.3zM75.719 238.704v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3zM117.867 238.704v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M160.039 238.704v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M202.188 238.704v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M244.328 238.704v22.601l19.775 11.3 19.776-11.3v-22.601l-19.776-11.3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M286.508 238.704v22.601l19.775 11.3 19.775-11.3v-22.601l-19.775-11.3z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M-29.117 58.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM13.047 58.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M55.195 58.808v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3zM97.336 58.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM139.516 58.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M181.656 58.808v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M223.805 58.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM265.977 58.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M308.125 58.808v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M-29.492 274.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M12.688 274.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM54.828 274.48v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M96.977 274.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M139.148 274.48v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M181.297 274.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM223.438 274.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M265.617 274.48v22.6l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3zM307.758 274.48v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M-8.148 95.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM34 95.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M76.148 95.083v22.601l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M118.32 95.083v22.601l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M160.469 95.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M202.617 95.083v22.601l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M244.758 95.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3zM286.938 95.083v22.601l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M329.078 95.083v22.601l19.775 11.3 19.776-11.3v-22.6l-19.776-11.3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M-8.516 310.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3zM33.633 310.755v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M75.79 310.755v22.6l19.774 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.12,
    d: "M117.945 310.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M160.102 310.755v22.6l19.775 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.04,
    d: "M202.242 310.755v22.6l19.775 11.301 19.776-11.301v-22.6l-19.776-11.3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M244.398 310.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3zM286.562 310.755v22.6l19.776 11.301 19.775-11.301v-22.6l-19.775-11.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#react-native-bg_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#react-native-bg_svg__e)",
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.456,
    cy: 65.207,
    fill: "#fff",
    rx: 35.456,
    ry: 65.207,
    transform: "matrix(-.87897 .47687 -.51789 -.85545 55.867 175.562)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#react-native-bg_svg__f)",
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.482,
    cy: 60.502,
    fill: "#fff",
    rx: 41.482,
    ry: 60.502,
    transform: "matrix(-.47195 .88162 -.91023 -.4141 141.891 140.965)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#react-native-bg_svg__g)",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.456,
    cy: 65.207,
    fill: "#fff",
    rx: 35.456,
    ry: 65.207,
    transform: "matrix(-.87897 .47687 -.51789 -.85545 353.87 51.562)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#react-native-bg_svg__h)",
    style: {
      mixBlendMode: "overlay"
    }
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.957,
    cy: 60.502,
    fill: "#fff",
    rx: 39.957,
    ry: 60.502,
    transform: "matrix(-.47195 .88162 -.91023 -.4141 385.768 71.968)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#31314A",
    d: "M286.937 95.083v22.601l19.776 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__i)",
    strokeLinecap: "round",
    strokeOpacity: 0.66,
    d: "m306.713 128.408-19.276-11.015v-22.02l19.276-11.014 19.275 11.015v22.019z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__j)",
    strokeLinecap: "round",
    strokeOpacity: 0.7,
    d: "m306.713 128.408-19.276-11.015v-22.02l19.276-11.014 19.275 11.015v22.019z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36374C",
    d: "M266 58.785v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__k)",
    strokeLinecap: "round",
    strokeOpacity: 0.66,
    d: "M285.775 92.109 266.5 81.095v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__l)",
    strokeLinecap: "round",
    strokeOpacity: 0.43,
    d: "M285.775 92.109 266.5 81.095v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#282840",
    d: "M224 58.785v22.6l19.775 11.3 19.775-11.3v-22.6l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__m)",
    strokeLinecap: "round",
    strokeOpacity: 0.66,
    d: "M243.775 92.109 224.5 81.095v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__n)",
    strokeLinecap: "round",
    strokeOpacity: 0.61,
    d: "M243.775 92.109 224.5 81.095v-22.02l19.275-11.015 19.275 11.015v22.02z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21232B",
    d: "M33.57 166.574v22.6l19.776 11.3 19.775-11.3v-22.6l-19.775-11.301z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__o)",
    strokeLinecap: "round",
    strokeOpacity: 0.66,
    d: "M53.346 199.898 34.07 188.884v-22.02l19.276-11.015 19.275 11.015v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__p)",
    strokeLinecap: "round",
    strokeOpacity: 0.43,
    d: "M53.346 199.898 34.07 188.884v-22.02l19.276-11.015 19.275 11.015v22.02z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F212A",
    d: "M12.326 201.899V224.5L32.1 235.8l19.775-11.3v-22.601l-19.775-11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__q)",
    strokeLinecap: "round",
    strokeOpacity: 0.66,
    d: "m32.1 235.224-19.274-11.015v-22.02L32.1 191.175l19.275 11.014v22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__r)",
    strokeLinecap: "round",
    strokeOpacity: 0.43,
    d: "m32.1 235.224-19.274-11.015v-22.02L32.1 191.175l19.275 11.014v22.02z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__s)",
    strokeOpacity: 0.68,
    strokeWidth: 1.4,
    d: "m32.51 189.608 20.767 11.995m0 0v23.431l-20.915 11.861m20.915-35.292 19-11",
    opacity: 0.75
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#react-native-bg_svg__t)",
    strokeOpacity: 0.68,
    strokeWidth: 1.4,
    d: "m264.547 56.54-.001 25.407m0 0 21.306 12.183 20.729-12.183m-42.035 0-20.2 12.183",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "react-native-bg_svg__v",
    width: 340,
    height: 328,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#react-native-bg_svg__u)",
    d: "M0 0h340v328H0z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#react-native-bg_svg__w)",
    mask: "url(#react-native-bg_svg__v)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.924,
    cy: 23.281,
    fill: "#828AA1",
    rx: 29.924,
    ry: 23.281,
    transform: "matrix(0 1 -.99792 .0645 6.79 135.744)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-205.49902 160.50145 -166.37307 -213.01678 330 14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#2A2B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2A2B42",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(112 -105.00003 108.84173 116.0978 -4 194)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#373B4A",
    stopOpacity: 0.475
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-8.49986 34.00004 -38.08007 -9.51985 326 76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(33 -38.5 43.12 36.96 289 129)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-32.0003 42.49978 -47.59974 -35.84033 313.523 40.977)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(37.5 -33.00003 36.96003 42 264 90.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(130.101 126.987 76.109)scale(49.679 55.6404)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(44.5 -38.00001 42.56004 49.84004 215 95.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(43.49997 40.49998 -45.36 48.71998 12 151.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-28.50012 -28.99991 32.47988 -31.92012 76.5 192.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(64.628 -138.437 90.138)scale(53.6773 60.1186)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29405C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "react-native-bg_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-23.07054 -42.7733 47.90608 -25.839 49.826 241.599)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "react-native-bg_svg__e",
    width: 190.306,
    height: 215.005,
    x: -104.221,
    y: 29.187,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5716_2048",
    stdDeviation: 24.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "react-native-bg_svg__f",
    width: 252.927,
    height: 224.669,
    x: -59.221,
    y: 40.148,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5716_2048",
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("filter", {
    id: "react-native-bg_svg__g",
    width: 190.306,
    height: 215.005,
    x: 193.782,
    y: -94.814,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5716_2048",
    stdDeviation: 24.6
  })), /*#__PURE__*/React.createElement("filter", {
    id: "react-native-bg_svg__h",
    width: 252.453,
    height: 222.463,
    x: 185.613,
    y: -29.091,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5716_2048",
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("filter", {
    id: "react-native-bg_svg__w",
    width: 153.865,
    height: 167.325,
    x: -93.376,
    y: 83.507,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_5716_2048",
    stdDeviation: 26.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "react-native-bg_svg__s",
    x1: 43.089,
    x2: 42.483,
    y1: 191.039,
    y2: 233.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111219",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#111219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#111219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#111219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111219",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "react-native-bg_svg__t",
    x1: 261.04,
    x2: 298.024,
    y1: 67.176,
    y2: 87.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181928",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#181928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#181928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#181928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "react-native-bg_svg__u",
    width: 0.353,
    height: 0.366,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-native-bg_svg__x",
    transform: "scale(.00294 .00305)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL0SURBVHgB7drBkYRADEPRzT8DciKn3giGklBzkPu/EzXFzuLDqIzbf3+Yb611/7i+fny+ftyzhOvb/L/ud17C9xxVL4BqD1FwCddu7LiR5UbuJdRyVL0AqoVd6BV8jxtrSoepRPFR9QKo9iIWknhMOtslPHMyxBhZL4BqS3uRV67dztMdMiixdgf3j6wXQLWlvbwncaFEnPsMd/C3R9ULoJrYxSWDBSVS3CjbFYPj6wVQ7UX36B7DuQtsbky5UXxUvQCqiR2ju7GQdJLuhkMSfePrBVBNjIXkKC1ZfnO7Yjeux9cLoJoYTUlH6kaiEmtuN5vMlqvrBVBNjIUtR1fi57vmvUrMjq8XQLWHTk85Mvt69vt1Fz2+XgDVXnSDu47P3KjcNUA4ql4A1R5+8knn6cbdMu93Y80daIypF0C1Zb44h5HodrC7ulZlI2JkvQCqrWyrIbnHjVBlPuzOe8fXC6Dai59/slf8RbTuOv4bWS+Aahtjyh0m7BpKKM//RSxX1Aug2sYuUXnxd+e0bsQl2x0j6wVQTYyI5JhMiTU34pJtiqPqBVBN7PSSo7ckstzIdTvP8fUCqBZ2ocrcNXlhV4YSbhQfVS+Aai9iIYnHpLN158zJUeCYegFUW9qLvHKdbEoke8LJJsb4egFUW/6SmBsXSsS5z3AHf3tUvQCqiV1cMlhQIsWNsl0xOL5eANVedI/uMZy7wObGlBvFR9ULoJrYMbobC0kn6W44JNE3vl4A1cRYSI7SkuU3tyt243p8vQCqidGUdKRuJCqx5nazyWy5ul4A1cRY2HJ0JX6+a96rxOz4egFUe+j0lCOzr2e/X3fR4+sFUO1FN7jr+MyNyl0DhKPqBVDt4SefdJ5u3C3zfjfW3IHGmHoBVFvmi3MYiW4Hu6trVTYiRtYLoNrKthqSe9wIVebD7rx3fL0Aqr34+Sd7xV9E667jv5H1Aqi2MabcYcKuoYTy/F/EckW9AKpt7BKVF393TutGXLLdMbJeDPYPkN6qZhcPlQEAAAAASUVORK5CYII=",
    id: "react-native-bg_svg__x",
    width: 120,
    height: 120
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpoweringCardItem1);
export default __webpack_public_path__ + "static/media/empowering-card-item1.962193a5e44365cd5ca90a80de528355.svg";
export { ForwardRef as ReactComponent };